import { preferredEnv } from './config'
import { readSession, sessionIsValid } from './session'
import { currentUser, login, logout, setSabreToken, verifyLogin } from './authActions'
import {
  createAgency,
  createAgencyPcc,
  createAgencyUser,
  createPaymentPlan,
  getSessionToken,
  listAgencies,
  listAgencyPccs,
  listAgencyUsers,
  listParentPccs,
  monitor,
  sabreResponse,
} from './agencyActions'
import {
  assignScript,
  assignScriptPcc,
  bulkAssign,
  createScript,
  getScriptConfig,
  listScriptCatalog,
  pccScripts,
  saveScriptConfig,
  savePccScriptAssignmentConfig,
  saveUserScriptAssignmentConfig,
  scriptsCatalog,
  updateScript,
  toggleScriptStatus,
  toggleScriptStatusPcc,
  unassignScript,
  unassignScriptPcc,
  userScripts,
} from './scriptActions'
import {
  createGlobalParameter,
  deleteGlobalParameter,
  listGlobalParameters,
  updateGlobalParameter,
} from './globalParameterActions'
import {
  activeDashboardPermission,
  deleteDashboardPermission,
  listDashboardPermissions,
  updateDashboardPermission,
} from './dashboardPermissionActions'
import {
  activateAIPrompt,
  createAIAdmin,
  deactivateAIAdmin,
  deleteAIAdmin,
  generateAIAssistant,
  statusAIAssistant,
  generateAIImporterAssistant,
  statusAIImporterAssistant,
  getAIAdmin,
  listAICustomScriptUsersByParentPcc,
  listAIUsersByParentPcc,
  listAIAdmin,
  publishReleaseAICustomScript,
  publishReleaseTestAICustomScript,
  publishTestAICustomScript,
  fetchPublishedAICustomScriptFile,
  registerAIAuditAction,
  saveDraftAICustomScript,
  updateAIAdmin,
  updateAIAdminStatus,
  upsertAISetting,
  validateAICustomScriptPublish,
} from './aiAdminActions'
export { cleanSabreToken } from './tokens'

const handlers = {
  me: () => {
    const session = readSession()
    return {
      email: session.email || '',
      has_jwt: sessionIsValid(session),
      has_sabre: Boolean(session.sabreToken),
      env: preferredEnv(),
      dashboardPermissions: session.dashboardPermissions || { scriptGenerator: false, repositories: false },
    }
  },
  current_user: currentUser,
  dashboard_permissions_update: updateDashboardPermission,
  dashboard_permissions_list: listDashboardPermissions,
  dashboard_permissions_save: updateDashboardPermission,
  dashboard_permissions_delete: deleteDashboardPermission,
  dashboard_permissions_active: activeDashboardPermission,
  login,
  login_verify: verifyLogin,
  set_sabre_token: setSabreToken,
  logout,
  list: listAgencies,
  create_payment_plan: createPaymentPlan,
  create_agency: createAgency,
  agency_pcc_create: createAgencyPcc,
  agency_user_create: createAgencyUser,
  scripts_catalog: scriptsCatalog,
  parent_pccs: listParentPccs,
  agency_users_list: listAgencyUsers,
  agency_pccs_list: listAgencyPccs,
  monitor,
  sabre_response: sabreResponse,
  get_session_token: getSessionToken,
  user_scripts: userScripts,
  pcc_scripts: pccScripts,
  script_config: getScriptConfig,
  scripts_manage: listScriptCatalog,
  script_create: createScript,
  script_update: updateScript,
  script_config_save: saveScriptConfig,
  user_script_config_save: saveUserScriptAssignmentConfig,
  pcc_script_config_save: savePccScriptAssignmentConfig,
  assign_script: assignScript,
  assign_script_pcc: assignScriptPcc,
  unassign_script: unassignScript,
  unassign_script_pcc: unassignScriptPcc,
  toggle_script_status: toggleScriptStatus,
  toggle_script_status_pcc: toggleScriptStatusPcc,
  bulk_assign: bulkAssign,
  global_parameters: listGlobalParameters,
  global_parameter_create: createGlobalParameter,
  global_parameter_update: updateGlobalParameter,
  global_parameter_delete: deleteGlobalParameter,
  ai_admin_list: listAIAdmin,
  ai_admin_get: getAIAdmin,
  ai_admin_create: createAIAdmin,
  ai_admin_update: updateAIAdmin,
  ai_admin_delete: deleteAIAdmin,
  ai_admin_assistant_generate: generateAIAssistant,
  ai_admin_assistant_status: statusAIAssistant,
  ai_admin_custom_scripts_save_draft: saveDraftAICustomScript,
  ai_admin_custom_scripts_validate_publish: validateAICustomScriptPublish,
  ai_admin_custom_scripts_publish_test: publishTestAICustomScript,
  ai_admin_custom_scripts_publish_release_test: publishReleaseTestAICustomScript,
  ai_admin_custom_scripts_publish_release: publishReleaseAICustomScript,
  ai_admin_custom_scripts_published_file: fetchPublishedAICustomScriptFile,
  ai_admin_custom_script_users_by_parentpcc: listAICustomScriptUsersByParentPcc,
  ai_admin_users_by_parentpcc: listAIUsersByParentPcc,
  ai_admin_status: updateAIAdminStatus,
  ai_admin_importer_assistant_generate: generateAIImporterAssistant,
  ai_admin_importer_assistant_status: statusAIImporterAssistant,
  ai_admin_activate_prompt: activateAIPrompt,
  ai_admin_deactivate: deactivateAIAdmin,
  ai_admin_upsert_setting: upsertAISetting,
  ai_admin_register_action: registerAIAuditAction,
}

export async function request(action, options = {}) {
  try {
    const handler = handlers[action]
    if (!handler) throw new Error(`Accion no implementada: ${action}`)
    if (!['me', 'login', 'login_verify'].includes(action) && !sessionIsValid()) {
      throw new Error('No autenticado. Inicia sesion nuevamente.')
    }
    const data = await handler(options.method === 'POST' ? options.body || {} : options.params || {})
    return { ok: true, data, status: 200 }
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 0,
      data: error.response?.data || { error: error.message || 'Error de red' },
    }
  }
}
